import { useCallback, useEffect, useState } from 'react';

import { EVENT_BROWSE_CATEGORY_TREE } from './eventCategoryBrowse';
import { fetchBrowseMenuTree, isBrowseMenuInventoryEnabled } from './fetchBrowseMenuTree';

/**
 * Returns inventory-filtered browse tree when discovery is enabled.
 * Falls back to static config if the API is unavailable.
 */
export const useBrowseMenuTree = (refreshKey = 0) => {
  const [menuTree, setMenuTree] = useState(EVENT_BROWSE_CATEGORY_TREE);
  const [loading, setLoading] = useState(isBrowseMenuInventoryEnabled());

  const load = useCallback(async () => {
    if (!isBrowseMenuInventoryEnabled()) {
      setMenuTree(EVENT_BROWSE_CATEGORY_TREE);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const categories = await fetchBrowseMenuTree();
      if (categories && categories.length > 0) {
        setMenuTree(categories);
      } else {
        setMenuTree([]);
      }
    } catch {
      setMenuTree(EVENT_BROWSE_CATEGORY_TREE);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return { menuTree, loading, reload: load };
};
